export class LocalStorageConfig {
  localStorageKey = {
    UserToken: 'UserToken',
    CurrentUser: 'CurrentUser',
    LocalLanguage: 'lang',
    Notification_Token: 'NoTo',
  }
}
